<header id="header" [ngClass]="{'sticky': !isHome, 'header': true, 'headerFixed': isInmuebles}">
  <a class="logo" routerLink="/"><img src="assets/img/logo.svg" alt="Logo RetailCo" width="150" /></a>
  <input aria-label="menu" class="menu-btn" type="checkbox" id="menu-btn" />
  <label class="menu-icon" for="menu-btn"><span class="navicon"></span></label>

  <!-- CON PILLS -->
  <ul class="menu">
    <li *ngFor="let item of menuItems" [class.nav-item]="item.subMenu" [attr.id]="item.id">
      <ng-container *ngIf="item.id !== 4; else clickableLink">
        <a [ngClass]="{'active': (item.id === 1 && isInmuebles) || (item.subMenu && isRetalkActive())}"
          routerLinkActive="active" [routerLink]="item.url">{{item.label}}</a>
      </ng-container>
      <ng-template #clickableLink>
        <a (click)="toggleSubMenu(item); $event.preventDefault()" class="nav-link"
          [ngClass]="{'active': item.id === 4 && isRetalkActive()}">{{item.label}} <svg width="24" height="24"
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.8746 9.00002L11.9946 12.88L8.11461 9.00002C7.72461 8.61002 7.09461 8.61002 6.70461 9.00002C6.31461 9.39002 6.31461 10.02 6.70461 10.41L11.2946 15C11.6846 15.39 12.3146 15.39 12.7046 15L17.2946 10.41C17.6846 10.02 17.6846 9.39002 17.2946 9.00002C16.9046 8.62002 16.2646 8.61002 15.8746 9.00002Z"
              fill="black" />
          </svg></a>
      </ng-template>

      <ul *ngIf="item.subMenu && item.isOpen" class="sub-menu">
        <li *ngFor="let subItem of item.subMenu" class="nav-item">
          <a [routerLink]="subItem.url" routerLinkActive="active-subm">{{subItem.label}}</a>
        </li>
      </ul>

    </li>
  </ul>

  <!-- <ul class="menu">
    <li *ngFor="let item of menuItems"><a routerLinkActive="active" routerLink="{{item.url}}">{{item.label}}</a></li>
  </ul> -->
</header>